// Проба голоса одной фразой: все голоса озвучивают фразу из админки, чтобы человек сравнивал голоса на одинаковой
// речи (владелец 06.10: «мозг человека работает не только на голос, но и на речь»). Файл пробы спрашиваем у сервера
// по первому нажатию (он синтезирует и кладёт в хранилище один раз на голос), дальше помним ссылку; нет фразы или
// синтез не удался — играем пробу ElevenLabs. Играет общий проигрыватель страницы «Озвучка» (useVoicePreview).
import { useCallback, useRef, useState } from 'react'
import { getVoiceProbe, type VoiceCard } from '../../api/voiceCatalog'
import { useVoicePreview } from '../../pages/generate/hooks/useVoicePreview'
import { asPreview } from './voicePreview'

export function useVoiceProbe() {
	const preview = useVoicePreview()
	// Ключ пробы, которая сейчас запрашивается у сервера (кнопка показывает ожидание).
	const [loading, setLoading] = useState<string | null>(null)
	// «персонаж:голос» → ссылка пробы фразой; null — фразы нет или синтез не удался (играем preview_url).
	const cache = useRef<Map<string, string | null>>(new Map())
	const seq = useRef(0)
	const { playing, toggle, stop } = preview

	/** Играть/остановить пробу голоса; key — чем помечать «играет» (у одинаковых голосов на разных плитках — свой);
	 *  characterId — чьей фразой (своя фраза персонажа важнее общей). */
	const play = useCallback(async (voice: VoiceCard, key: string = voice.id, characterId?: string | null) => {
		if (playing === key) { toggle({ ...asPreview(voice), id: key }); return }
		const cacheKey = `${characterId ?? ''}:${voice.id}`
		let url = cache.current.get(cacheKey)
		if (url === undefined) {
			const my = ++seq.current
			setLoading(key)
			try {
				url = (await getVoiceProbe(voice.id, characterId)).url ?? null
			} catch {
				url = null
			}
			cache.current.set(cacheKey, url)
			if (my !== seq.current) return // пока ждали, нажали другую пробу
			setLoading(null)
		}
		toggle({ ...asPreview(voice), id: key, sample: url ?? voice.preview_url })
	}, [playing, toggle])

	return { playing, loading, play, stop }
}
